/**
 * Bulk Actions control: menu trigger (Mark as Done only) and confirm modal for the redesigned list.
 */
import { observer } from "mobx-react";
import { useState } from "react";
import { Button } from "../../../../../components/inputs/button/button";
import { BUTTON_VARIANTS } from "../../../../../components/inputs/button-variants";
import useDashboardTranslation from "../../../../../dashboard-translation/hooks/dashboard-translation-hook";
import rmaPagedListStore from "../../stores/rma-tabs-paged-list-store";
import bulkRmaActionStore from "../../stores/bulk-rma-action-store";
import RmaListBulkActionsMenu from "../rma-list-bulk-actions-menu/rma-list-bulk-actions-menu";
import RmaListBulkMarkDoneConfirmModal from "../rma-list-bulk-mark-done-confirm-modal/rma-list-bulk-mark-done-confirm-modal";
import { BULK_RMA_ACTION } from "../../../../../services/api/bulk-rma-action-types";
import rmsMixpanelStore from "../../../../../stores/rms-mixpanel-store";
import "./rma-list-bulk-actions-control.scss";

const RmaListBulkActionsControl: React.FC = observer(() => {
    const { getTranslation } = useDashboardTranslation();
    const scope = "dashboard-returns-page";
    const [menuOpen, setMenuOpen] = useState(false);
    const [confirmOpen, setConfirmOpen] = useState(false);
    const bulkSelectionStore = rmaPagedListStore.bulkSelectionStore;

    const count = bulkSelectionStore.selectionCount(rmaPagedListStore.total);
    const disabled =
        count <= 0 ||
        bulkSelectionStore.isBlocked ||
        bulkRmaActionStore.isStarting;

    const onConfirm = async () => {
        const payload = bulkSelectionStore.buildStartPayload();
        const confirmedCount = count;
        bulkSelectionStore.clear();
        setConfirmOpen(false);
        setMenuOpen(false);
        if (!payload) {
            return;
        }
        rmsMixpanelStore.trackEvent("d&_bulk_mark_done_confirm", { count: confirmedCount });
        await bulkRmaActionStore.startAction(BULK_RMA_ACTION.MARK_DONE, payload);
    };

    return (
        <div className="rma-list-bulk-actions-control">
            <Button
                variant={BUTTON_VARIANTS.Secondary}
                text={getTranslation("BULK_ACTIONS", scope)}
                disabled={disabled}
                onClick={() => setMenuOpen((open) => !open)}
            />
            {menuOpen && !disabled && (
                <RmaListBulkActionsMenu
                    onMarkDone={() => {
                        setMenuOpen(false);
                        setConfirmOpen(true);
                    }}
                    onClose={() => setMenuOpen(false)}
                />
            )}
            {confirmOpen && (
                <RmaListBulkMarkDoneConfirmModal
                    selectionCount={count}
                    isLoading={bulkRmaActionStore.isStarting}
                    onCancel={() => setConfirmOpen(false)}
                    onConfirm={onConfirm}
                />
            )}
        </div>
    );
});

export default RmaListBulkActionsControl;
